import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentPage = {
  footer: {
    root: 'loan-document-page.footer.root',
  },
  form: {
    h1: 'loan-document-page.form.h1',
    h2: 'loan-document-page.form.h2',
    root: 'loan-document-page.form.root',
    submitButton: 'loan-document-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
